export enum Suits {
    BAMBOO = 'bamboo',
    DOTS = 'dots',
    CHARACTERS = 'characters',
    WINDS = 'winds',
    DRAGON = 'dragon',
    FLOWERS = 'flowers',
    SEASONS = 'seasons',
    GOLD = 'gold',
    BOOSTER = 'booster',
    SPECIAL = 'special',
}
